<p>users-tools-edit-cavok works!</p>

<ng-container *ngFor="let element of getFormConfigs()">

  <ng-container *ngIf="element['fieldtype']==='text'">
    <div class="form-group ">
      <label>{{element['fieldlabel']}}</label>
      <input type="text" class="form-control form-control-sm" formControlName="{{element['field']}}"
             [ngClass]="{'is-invalid': isFieldWithError(element['field'])}"
      />
      <div class="invalid-feedback">
        Mandatory {{element['field']}}
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="element['fieldtype']==='select'">
    <div class="form-group form-control-sm">
      <label>{{element['fieldlabel']}}</label>
      <select class="form-control form-control-sm" formControlName="{{element['field']}}"
              [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">
        <option *ngFor="let item of element['choices']" value="{{item['id']}}">
          {{item['label']}}
        </option>
      </select>
      <div class="invalid-feedback">
        Mandatory {{element['field']}}
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="element['fieldtype']==='checkbox'">
    <div class="form-group">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" formControlName="{{element['field']}}">
        <label class="form-check-label"
               [ngClass]="{'is-invalid': isFieldWithError(element['field'])}">{{element['fieldlabel']}}</label>
      </div>
    </div>
  </ng-container>

</ng-container>

